import { render, staticRenderFns } from "./CreateProjectView.vue?vue&type=template&id=51a6e5ec"
import script from "./CreateProjectView.vue?vue&type=script&lang=ts"
export * from "./CreateProjectView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports